/**
 * Build-time feature flags (CRA `REACT_APP_*` — baked in at build time).
 *
 * APP_STUDIO_ENABLED gates the new "3D App Studio" (`/3dapp-studio`) so it can
 * be hidden where it isn't ready (staging + production) while it matures in
 * dev. The legacy App Builder (`/app-builder`) is always available and is NOT
 * affected by this flag.
 *
 * Default: ENABLED. Set `REACT_APP_ENABLE_APP_STUDIO=false` in a build (staging
 * and production pipelines) to hide the 3D App Studio route + entry points.
 */
export const APP_STUDIO_ENABLED = process.env.REACT_APP_ENABLE_APP_STUDIO !== 'false';
